import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { searchTenantMembers } from '../../api/tenantMembers';
import type { SearchMembersParams } from '../../types/chat';
import { chatKeys } from './chatKeys';

function useDebounced<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}

export function useTenantMembers(params: SearchMembersParams = {}) {
  const debouncedSearch = useDebounced(params.search ?? '', 250);
  const effective: SearchMembersParams = {
    ...params,
    search: debouncedSearch || undefined,
  };

  return useQuery({
    queryKey: chatKeys.tenantMembers(effective),
    queryFn: () => searchTenantMembers(effective),
    staleTime: 30_000,
  });
}
